export const AUTH_RETURN_TO_STORAGE_KEY = 'auth.returnTo';
export const DEFAULT_AUTH_RETURN_TO = '/';

const VALIDATION_ORIGIN = 'https://whatyouwish.invalid';
const URI_SCHEME = /^[a-z][a-z\d+.-]*:/i;

const hasControlCharacters = (value) => {
  for (let index = 0; index < value.length; index += 1) {
    const code = value.charCodeAt(index);
    if (code < 32 || code === 127) {
      return true;
    }
  }

  return false;
};

const decodeForValidation = (value) => {
  let decoded = value;

  for (let attempt = 0; attempt < 8; attempt += 1) {
    let next;

    try {
      next = decodeURIComponent(decoded);
    } catch {
      return null;
    }

    if (next === decoded) {
      return decoded;
    }

    decoded = next;
  }

  return null;
};

export const isSafeRelativeRoute = (route) => {
  if (typeof route !== 'string' || route.length === 0 || !route.startsWith('/')) {
    return false;
  }

  if (route.startsWith('//') || route.includes('\\') || hasControlCharacters(route)) {
    return false;
  }

  const decodedRoute = decodeForValidation(route);
  if (
    !decodedRoute
    || decodedRoute.startsWith('//')
    || decodedRoute.includes('\\')
    || hasControlCharacters(decodedRoute)
    || URI_SCHEME.test(decodedRoute)
  ) {
    return false;
  }

  try {
    const parsedRoute = new URL(route, VALIDATION_ORIGIN);
    return parsedRoute.origin === VALIDATION_ORIGIN;
  } catch {
    return false;
  }
};

export const getCurrentRoute = (location) => {
  const pathname = typeof location?.pathname === 'string' ? location.pathname : DEFAULT_AUTH_RETURN_TO;
  const search = typeof location?.search === 'string' ? location.search : '';
  const hash = typeof location?.hash === 'string' ? location.hash : '';
  const route = `${pathname}${search}${hash}`;

  return isSafeRelativeRoute(route) ? route : DEFAULT_AUTH_RETURN_TO;
};

const getSessionStorage = () => {
  try {
    return typeof window === 'undefined' ? null : window.sessionStorage;
  } catch {
    return null;
  }
};

export const saveAuthReturnTo = (route, storage = getSessionStorage()) => {
  if (!storage) {
    return false;
  }

  try {
    if (!isSafeRelativeRoute(route)) {
      storage.removeItem(AUTH_RETURN_TO_STORAGE_KEY);
      return false;
    }

    storage.setItem(AUTH_RETURN_TO_STORAGE_KEY, route);
    return true;
  } catch {
    return false;
  }
};

export const consumeAuthReturnTo = (storage = getSessionStorage()) => {
  if (!storage) {
    return DEFAULT_AUTH_RETURN_TO;
  }

  try {
    const route = storage.getItem(AUTH_RETURN_TO_STORAGE_KEY);
    storage.removeItem(AUTH_RETURN_TO_STORAGE_KEY);

    return isSafeRelativeRoute(route) ? route : DEFAULT_AUTH_RETURN_TO;
  } catch {
    return DEFAULT_AUTH_RETURN_TO;
  }
};

export const getTwitchAuthorizationUrl = (
  backendBaseUrl = process.env.REACT_APP_BACKEND_BASE_URL
) => {
  if (!backendBaseUrl) {
    throw new Error('REACT_APP_BACKEND_BASE_URL is required for Twitch login.');
  }

  return `${backendBaseUrl.replace(/\/+$/, '')}/oauth2/authorization/twitch`;
};
